var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "#494dcb",
    strokeWidth: 1.25
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.377,
    y: 3.016,
    width: 21.246,
    height: 25.967,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.377 3.607l10.207 6.805a.75.75 0 00.832 0l10.207-6.805"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIiBzdHJva2U9IiM0OTRkY2IiIHN0cm9rZS13aWR0aD0iMS4yNSIgeG1sbnM6dj0iaHR0cHM6Ly92ZWN0YS5pby9uYW5vIj48cmVjdCB4PSI1LjM3NyIgeT0iMy4wMTYiIHdpZHRoPSIyMS4yNDYiIGhlaWdodD0iMjUuOTY3IiByeD0iMSIvPjxwYXRoIGQ9Ik01LjM3NyAzLjYwN2wxMC4yMDcgNi44MDVhLjc1Ljc1IDAgMCAwIC44MzIgMGwxMC4yMDctNi44MDUiLz48L3N2Zz4=";
export { SvgIconCash as ReactComponent };